import { render, staticRenderFns } from "./VuesticPopover.vue?vue&type=template&id=02321376&scoped=true"
import script from "./VuesticPopover.vue?vue&type=script&lang=js"
export * from "./VuesticPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02321376",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-popover/VuesticPopover.vue
// module id = ihPg
// module chunks = 41